// extracted by mini-css-extract-plugin
module.exports = {"container":"CashFlowWidget_container__2tSN0","widget":"CashFlowWidget_widget__2SXqO","loading":"CashFlowWidget_loading__2dkPh"};